import airbridgeModule from 'airbridge-web-sdk-loader';

type AirbridgeModule = typeof airbridgeModule & { default?: typeof airbridgeModule };

const airbridge = (airbridgeModule as AirbridgeModule).default ?? airbridgeModule;

export default airbridge;
